import { render, staticRenderFns } from "./teachers-weeklyplan.vue?vue&type=template&id=621f62b7&"
import script from "./teachers-weeklyplan.vue?vue&type=script&lang=js&"
export * from "./teachers-weeklyplan.vue?vue&type=script&lang=js&"
import style0 from "./teachers-weeklyplan.vue?vue&type=style&index=0&id=621f62b7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports